// extracted by mini-css-extract-plugin
export default {"removeModalText":"ManifestRemoveModal__removeModalText-LjEro"};